import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';

@Component({
    selector: 'lsq-legal-document',
    styleUrls: ['./legal-document.component.scss'],
    template: `
        <div class="legal-document">
            <card [headerTitle]="documentName">
                <div
                    card-body
                    [style.padding]="'3rem'"
                    [style.maxHeight]="'49rem'"
                    [style.overflow]="'hidden'"
                    [style.overflowY]="'scroll'"
                    (scroll)="onScroll($event)"
                >
                    <div class="legal-document-body" [innerHtml]="content"></div>
                    <div *ngIf="!content" card-body>
                        <lsq-circle-loader></lsq-circle-loader>
                    </div>
                </div>
            </card>
        </div>
    `
})
export class LsqLegalDocumentComponent {
    @Input() public content: any;
    @Input() public documentName: string;
    @Output() public scrolledToBottom = new EventEmitter();

    public icons = Icons;
    public colors = Color;

    @HostListener('scroll', ['$event'])
    public onScroll(event: any) {
        const SCROLL_BUFFER = 10;
        if (
            event.target.offsetHeight + event.target.scrollTop >=
            event.target.scrollHeight - SCROLL_BUFFER
        ) {
            this.scrolledToBottom.emit();
        }
    }
}
